module.exports = __webpack_public_path__ + "newWebTMS/img/frame.4b328380.svg";